"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingTarget = exports.GroupType = exports.ChannelType = exports.MessageSubType = exports.MessageType = exports.AttachmentInvalidReason = exports.AttachmentType = exports.MessageActionType = void 0;
exports.MessageActionType = {
    Text: 'text',
    OpenUrl: 'open_url',
};
exports.AttachmentType = {
    Card: 'card',
    Cards: 'cards',
    File: 'file',
    Image: 'image',
    Media: 'media',
    Invalid: 'invalid',
};
exports.AttachmentInvalidReason = {
    InvalidSize: 'invalid_size',
    InvalidType: 'invalid_type',
};
exports.MessageType = {
    Message: 'message',
    Event: 'event',
    Help: 'help',
};
exports.MessageSubType = {
    Agent: 'agent',
    Contact: 'contact',
    Trigger: 'trigger',
    Bot: 'bot',
    System: 'system',
    AgentExternal: 'agent_external',
    FoundEmail: 'found_email',
    ChatResolve: 'chat_resolve',
};
exports.ChannelType = {
    Default: 'default',
    Email: 'email',
    EmailIntegration: 'email_integration',
    FacebookMessenger: 'facebook_messenger',
    Gmail: 'gmail',
    Smartsupp: 'smartsupp',
    Whatsapp: 'whatsapp',
};
var GroupType;
(function (GroupType) {
    GroupType["ai"] = "ai";
    GroupType["chatbot"] = "chatbot";
    GroupType["message"] = "message";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
var RatingTarget;
(function (RatingTarget) {
    RatingTarget["Agent"] = "agent";
    RatingTarget["Ai"] = "ai";
})(RatingTarget = exports.RatingTarget || (exports.RatingTarget = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZW51bXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxpQkFBaUIsR0FBRztJQUNoQyxJQUFJLEVBQUUsTUFBTTtJQUNaLE9BQU8sRUFBRSxVQUFVO0NBQ1YsQ0FBQTtBQUdHLFFBQUEsY0FBYyxHQUFHO0lBQzdCLElBQUksRUFBRSxNQUFNO0lBQ1osS0FBSyxFQUFFLE9BQU87SUFDZCxJQUFJLEVBQUUsTUFBTTtJQUNaLEtBQUssRUFBRSxPQUFPO0lBQ2QsS0FBSyxFQUFFLE9BQU87SUFDZCxPQUFPLEVBQUUsU0FBUztDQUNULENBQUE7QUFHRyxRQUFBLHVCQUF1QixHQUFHO0lBQ3RDLFdBQVcsRUFBRSxjQUFjO0lBQzNCLFdBQVcsRUFBRSxjQUFjO0NBQ2xCLENBQUE7QUFHRyxRQUFBLFdBQVcsR0FBRztJQUMxQixPQUFPLEVBQUUsU0FBUztJQUNsQixLQUFLLEVBQUUsT0FBTztJQUNkLElBQUksRUFBRSxNQUFNO0NBQ0gsQ0FBQTtBQUdHLFFBQUEsY0FBYyxHQUFHO0lBQzdCLEtBQUssRUFBRSxPQUFPO0lBQ2QsT0FBTyxFQUFFLFNBQVM7SUFDbEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsR0FBRyxFQUFFLEtBQUs7SUFDVixNQUFNLEVBQUUsUUFBUTtJQUNoQixhQUFhLEVBQUUsZ0JBQWdCO0lBQy9CLFVBQVUsRUFBRSxhQUFhO0lBQ3pCLFdBQVcsRUFBRSxjQUFjO0NBQ2xCLENBQUE7QUFHRyxRQUFBLFdBQVcsR0FBRztJQUMxQixPQUFPLEVBQUUsU0FBUztJQUNsQixLQUFLLEVBQUUsT0FBTztJQUNkLGdCQUFnQixFQUFFLG1CQUFtQjtJQUNyQyxpQkFBaUIsRUFBRSxvQkFBb0I7SUFDdkMsS0FBSyxFQUFFLE9BQU87SUFDZCxTQUFTLEVBQUUsV0FBVztJQUN0QixRQUFRLEVBQUUsVUFBVTtDQUNYLENBQUE7QUFHVixJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDcEIsc0JBQVMsQ0FBQTtJQUNULGdDQUFtQixDQUFBO0lBQ25CLGdDQUFtQixDQUFBO0FBQ3BCLENBQUMsRUFKVyxTQUFTLEdBQVQsaUJBQVMsS0FBVCxpQkFBUyxRQUlwQjtBQUVELElBQVksWUFHWDtBQUhELFdBQVksWUFBWTtJQUN2QiwrQkFBZSxDQUFBO0lBQ2YseUJBQVMsQ0FBQTtBQUNWLENBQUMsRUFIVyxZQUFZLEdBQVosb0JBQVksS0FBWixvQkFBWSxRQUd2QiJ9